/**
 * Created by PuTi(编程即菩提) 3/11/17.
 * nb default model List
 */
module.exports = function (nb) {
    var opts = nb.opts;
    var $ = opts.$;
    var List = nb.define({
        parent: nb.Model,
        method: {
            init: function () {
                this.onChange('items', function (inEvent) {
                    var list = inEvent.data || [];
                    var array = [];
                    var self = this;
                    $.each(list, function (inIndex, inItem) {
                        var model = self.createItemModel(inIndex, inItem);
                        array.push(model);
                    });
                    return array;
                }, this, {before: true});
                this.onChange('appendItems', function (inEvent, inItems) {
                    var items = inItems;
                    var array = [];
                    var self = this;
                    var currentItems = this.get('items');
                    var index = currentItems? currentItems.length:0;

                    $.each(items, function (inIndex, inItem) {
                        var model = self.createItemModel(index + inIndex, inItem);
                        array.push(model);
                        currentItems.push(model);
                    });
                    return array;
                }, this, {before: true});
                this.onChange('activeIndex', function (inEvent, inIndex) {
                    var lastIndex = inEvent.origin;
                    var items = this.get('items');
                    var last = items[lastIndex];
                    var current = items[inIndex];
                    if (last) {
                        last.set('active', '');
                    }
                    if (current) {
                        current.set('active', 'active')
                    }
                }, this);
            },
            getItemModelType: function (inIndex, inItem) {
                var itemModelType = this.get('itemModelType') || nb.Model;
                return itemModelType;
            },
            createItemModel: function (inIndex, inItem) {
                var model = inItem;
                var type;
                if ($.isPlainObject(inItem)) {
                    type = this.getItemModelType(inIndex, inItem);
                    model = new type;
                }
                model.setOpts(inItem);
                return model;
            }
        }
    });
    nb.name('model.List', List, nb);
};


//////////////////
// WEBPACK FOOTER
// ../src/nb/core/js/core/model/list.js
// module id = 212
// module chunks = 35